import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { drawerWidth } from '../../../styleVariables';

const useStyles = makeStyles(theme => ({

    sideBarV1: {
        height: 'calc(100vh - 57px)',
        width: 270,
        backgroundColor: '#6b778c',
        color: 'white',
        marginLeft: '-2em',
        marginTop: '-2em'
    },
    sideBarV2: {
        height: 'calc(100vh - 57px)',
        width: 270,
        backgroundColor: '#6b778c',
        color: 'white',
        marginLeft: '-2em',
        marginTop: '2em',
        borderTopRightRadius:8
    },
    sideBarList: {
        height: '100%',
        width: '100%',
        "&:hover": {
            cursor: 'pointer',
            backgroundColor: '#293846'
        }
    },
    row: {
        width: '100%',
        listStyleType: 'none',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        '#:active': {
            backgroundColor: '#293846'
        }
    },
    drawerPaper: {
        position: 'relative',
        width: drawerWidth,
        maxWidth: drawerWidth,
        height: '100%',
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '56px!important'
        },
        [theme.breakpoints.up('sm')]: {
            top: '64px!important'
        },
        zIndex: '1000!important'
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '64px'
        }
    },
    menuList: {
        padding: '24px 8px',
        paddingLeft:22,
        "& a": {
            fontSize: 14,
            color: 'white !important'
        }
    },
    verifiedDiv: {
        textAlign: 'center',
        alignItems: 'center',
        textAlign: 'center',
        position: 'fixed',
        bottom: 0,
        paddingBottom: 40,
        paddingTop: 20,
        maxWidth: 269,
        width: '100%',
        backgroundColor: '#fff',
        //borderTop:'1px solid #f1f1f1'
    },
    badge: {
        width: '20px',
        height: '20px',
        display: 'flex',
        zIndex: 1,
        flexWrap: 'wrap',
        fontSize: '0.75rem',
        alignItems: 'center',
        borderRadius: '50%',
        alignContent: 'center',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    menuLink: {
        position: 'relative',
        display: 'block',
        color: 'inherit',
        textDecoration: 'none',
        "&:hover": {
            textDecoration:'none'
        },
    },
    menuItem: {
        paddingRight: 0,
        paddingLeft: '24px',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: theme.spacing(1) * 1.5,
        paddingBottom: theme.spacing(1) * 1.5,
        '& .MuiTypography-root': {
            fontWeight: 300
        }
    },
    menuIcon: {
        marginLeft: theme.spacing(1) * 2,
        marginRight: theme.spacing(1) * 2
    },
    menuSubItem: {
        paddingLeft: '55px',
        paddingRight: '55px',
        paddingTop: theme.spacing(1) * 1.5,
        paddingBottom: theme.spacing(1) * 1.5
    },
    menuCollapsed: {
        // backgroundColor: theme.palette.action.hover
    },
    menuActive: {
        backgroundColor: 'white',
        borderRadius: 4,
        color: 'black !important',
        '& .MuiListItemIcon-root': {
            color: 'grey !important'
        },
        '& .MuiTypography-root': {
            color: 'black !important'
        }
    },
    menuClosed: {
        backgroundColor: 'transparent'
    },
    caret: {
        marginLeft: theme.spacing(1) * 2,
        marginRight: theme.spacing(1) * 2,
        minWidth: 0
    },
    primary: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    secondary: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText
    },
    error: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    },
    liV1: {
        minWidth: 0, color: 'white'
    },
    mtV2: {
        marginLeft: '19px'
    },
    featureName: {
        fontSize: 22,
        fontWeight: 300
    },
    brV1: {
        borderRadius: '16px'
    },
    divV1: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    profitReportIcon: {
        backgroundColor: '#f4f4f5',
        fontSize: 50,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 8
    },
    receiptGreenIcon: {
        backgroundColor: '#f4f4f5',
        fontSize: 50,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 8
    },
    receiptRedIcon: {
        backgroundColor: '#f4f4f5',
        fontSize: 50,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 8
    },
    gridItems: {
        cursor: 'pointer',
    },
    dialogTitleV1: {
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 20,
        paddingRight: 10
    },
    dialogContentV1: {
        paddingTop: 0, paddingBottom: '0px !important', paddingLeft: 0, paddingRight: 0
    },
    paperWidth: {
        maxWidth: 514
    },
    dividerMargin: {
        marginLeft: 90
    },
    listItemV1: {
        paddingTop: 10, paddingBottom: 10, paddingLeft: 16, paddingRight: 16
    },
    profitLossIcon: {
        fontSize: '5em', marginRight: 16, marginLeft: "-12px"
    },
    arrowForward: {
        color: 'lightgrey', fontSize: 22
    },
    listItemV2:{
        paddingTop: 10, paddingBottom: 16, paddingLeft: 16, paddingRight: 16
    },
    listItemV3: {
        paddingTop: 10, paddingBottom: 18, paddingLeft: 16, paddingRight: 16
    },
    iconV1: {
        fontSize: '4em', marginRight: 16
    },
    primaryText: {
        fontSize: 20,
        fontWeight: 300
    },
    secondaryText: {
        marginTop: 4
    },
    marginTopV1: {
        // marginTop: 16
    },
    listItemLogout: {
        padding: '0px'
    },
    divLogoutOuter: {
        width: '100%', paddingLeft: 16, paddingRight: 8
    },
    divLogoutInner: {
        display: 'flex', marginLeft: 8, marginRight: 8, border: '1px solid white', borderRadius: '8px', padding: 12, paddingLeft: 16, alignItems: 'center'
    },
    divLogout: {
        fontSize: 16, marginLeft: 16
    }
}));

export default useStyles